import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CONFIG_CONSTANTS, API_CONSTANTS } from '@finder/shared/constants/app.constants';
import { ConfigService } from '@finder/core/config.service';
import getApiBase from '@finder/shared/utils/string/getApiBase';

const apiUrlKey = CONFIG_CONSTANTS.apiUrlKey;
const siteIdKey = CONFIG_CONSTANTS.siteIdKey;
const defaultVersionKey = CONFIG_CONSTANTS.defaultVersionKey;
const mediaServiceEndpoint = API_CONSTANTS.mediaServiceEndpoint;

@Injectable()
export class MediaServiceConnectorService {

    private baseUrl: string;
    private version: string;
    private siteId: string;

    constructor(
        private http: HttpClient,
        private config: ConfigService
    ) {
        this.baseUrl = this.config.getValue(apiUrlKey);
        this.version = this.config.getValue(defaultVersionKey);
        this.siteId = this.config.getValue(siteIdKey);
    }

    /**
     * Makes a GET request to media-svc api endpoint
     *
     * @param id        facility ID
     * @param version   endpoint version (optional)
     */
    public getBundle(id: string, version?: string): Observable<any> {
        const url = this.constructUrl(mediaServiceEndpoint, this.baseUrl, id, this.siteId, version);

        return this.http.get(url);
    }

    /**
     * Constructs endpoint URL
     *
     * @param endpoint  media-svc endpoint
     * @param baseUrl   base URL
     * @param id        facility ID
     * @param siteId    site ID
     * @param version   api version -- defaulted to v1
     */
    private constructUrl(
        endpoint: string,
        baseUrl: string,
        id: string,
        siteId: string,
        version: string = this.version
    ): string {
        const apiBase = getApiBase(baseUrl, version);

        return `${apiBase}/${endpoint}/${siteId}/${id}/`;
    }
}
